import { render, staticRenderFns } from "./component.ai-chat.vue?vue&type=template&id=8568b656"
import script from "./component.ai-chat.vue?vue&type=script&lang=js"
export * from "./component.ai-chat.vue?vue&type=script&lang=js"
import style0 from "./component.ai-chat.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports